export default "__VITE_ASSET__037c3d8f__"